import React from 'react';
import './App.css';

function Loading() {
  return (
    <div className="loading main">
      <h1>Loading...</h1>
    </div>
  );
}

export default Loading;
